import { render } from "./Questions.vue?vue&type=template&id=3ee55d65&scoped=true"
import script from "./Questions.vue?vue&type=script&lang=js"
export * from "./Questions.vue?vue&type=script&lang=js"

import "./Questions.vue?vue&type=style&index=0&id=3ee55d65&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3ee55d65"

export default script